import React from 'react';
import { List, Popup } from '@gravity-ui/uikit';
import { cn } from '../../../../classname';
import { i18n } from '../../../../i18n/suggest';
import { ErrorLoggerBoundary } from '../../../../react-utils/ErrorBoundary';
import './EmojiSuggestComponent.css';
const b = cn('emoji-suggest');
const placement = ['bottom-start', 'top-start', 'bottom-end', 'top-end'];
const ITEM_HEIGHT = 28; // px
const VISIBLE_ITEMS_COUNT = 10;
const MAX_LIST_HEIGHT = ITEM_HEIGHT * VISIBLE_ITEMS_COUNT; // px
function calcListHeight(itemsCount) {
    if (itemsCount <= 0)
        return undefined;
    return Math.min(MAX_LIST_HEIGHT, itemsCount * ITEM_HEIGHT);
}
export const EmojiSuggestComponent = ({ anchor, currentIndex, items, onClick, onEnterKeyDown, onEscapeKeyDown, onOutsideClick, }) => {
    if (!anchor)
        return null;
    return (React.createElement(Popup, { open: true, anchorRef: { current: anchor }, placement: placement, onEnterKeyDown: onEnterKeyDown, onEscapeKeyDown: onEscapeKeyDown, onOutsideClick: onOutsideClick },
        React.createElement("div", { className: b() },
            React.createElement(List, { virtualized: true, items: items, sortable: false, filterable: false, emptyPlaceholder: i18n('empty-msg'), itemHeight: ITEM_HEIGHT, itemsHeight: calcListHeight(items.length), renderItem: renderItem, deactivateOnLeave: false, activeItemIndex: currentIndex, onItemClick: (_item, index) => onClick(index), className: b('list'), itemClassName: b('list-item') }))));
};
function renderItem({ origName, symbol, origShortcuts }) {
    return (React.createElement("div", { key: origName, className: b('item') },
        React.createElement("div", { className: b('item-info') },
            React.createElement("div", { className: b('item-icon') }, symbol),
            React.createElement("div", { className: b('item-name') },
                ":",
                origName,
                ":")),
        origShortcuts !== undefined && (React.createElement("div", { className: b('item-shortcuts') }, origShortcuts.slice(0, 4).map((val) => (React.createElement("span", { key: `${origName}_${val}`, className: b('item-shortcut') }, val)))))));
}
export function render(props) {
    return (React.createElement(ErrorLoggerBoundary, null,
        React.createElement(EmojiSuggestComponent, Object.assign({}, props))));
}
